module.exports = __webpack_public_path__ + "static/media/white-city.7438f9a2.jpg";